import * as TypDokladu from "./../api/gen/proxioapi/TypDokladu";

const labels = {
    [TypDokladu.ID]: "Občanský průkaz",
    [TypDokladu.P]: "Cestovní doklad",
    [TypDokladu.OSTATNI]: "Ostatní",
    [TypDokladu.IR]: "Povolení k pobytu",
    [TypDokladu.VS]: "Vízový štítek",
    [TypDokladu.PS]: "Pobytový štítek",
    [TypDokladu.RP]: "Řidičský průkaz",
};

export function label(typ) {
    return labels[typ];
};
